module.exports = __webpack_public_path__ + "img/ocr_tips.86548b37.png";